"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _console = require("@instructure/console");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));
var _findFocusable = _interopRequireDefault(require("@instructure/ui-a11y/lib/utils/findFocusable"));
var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));
var _matchComponentTypes = _interopRequireDefault(require("@instructure/ui-utils/lib/react/matchComponentTypes"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _isActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/isActiveElement"));
var _findDOMNode = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/findDOMNode"));
var _hasVisibleChildren = _interopRequireDefault(require("@instructure/ui-a11y/lib/utils/hasVisibleChildren"));
var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _theme = _interopRequireDefault(require("./theme"));
var _dec, _dec2, _dec3, _class, _class2, _temp;
var styles = {
  componentId: 'cIcZl',
  template: function template(theme) {
    return "\n\n.cIcZl_bGBk,a.cIcZl_bGBk:link,a.cIcZl_bGBk:visited,button.cIcZl_bGBk{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;box-sizing:border-box;font-family:".concat(theme.fontFamily || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";outline-color:transparent;outline-offset:0.25rem;outline-style:").concat(theme.focusOutlineStyle || 'inherit', ";outline-width:").concat(theme.focusOutlineWidth || 'inherit', ";transition:outline-color 0.2s;vertical-align:baseline}\n\n.cIcZl_bGBk:focus,a.cIcZl_bGBk:link:focus,a.cIcZl_bGBk:visited:focus,button.cIcZl_bGBk:focus{outline-color:").concat(theme.focusOutlineColor || 'inherit', "}\n\n.cIcZl_bGBk[aria-disabled],a.cIcZl_bGBk:link[aria-disabled],a.cIcZl_bGBk:visited[aria-disabled],button.cIcZl_bGBk[aria-disabled]{cursor:not-allowed;opacity:0.5;pointer-events:none}\n\n.cIcZl_bGBk::-moz-focus-inner,a.cIcZl_bGBk:link::-moz-focus-inner,a.cIcZl_bGBk:visited::-moz-focus-inner,button.cIcZl_bGBk::-moz-focus-inner{border:0}\n\na.cIcZl_bGBk:link,a.cIcZl_bGBk:visited,button.cIcZl_bGBk{-webkit-text-decoration:").concat(theme.textDecoration || 'inherit', ";color:").concat(theme.color || 'inherit', ";cursor:pointer;text-decoration:").concat(theme.textDecoration || 'inherit', "}\n\na.cIcZl_bGBk:link:focus,a.cIcZl_bGBk:visited:focus,button.cIcZl_bGBk:focus{color:").concat(theme.color || 'inherit', "}\n\na.cIcZl_bGBk:link:active,a.cIcZl_bGBk:link:hover,a.cIcZl_bGBk:visited:active,a.cIcZl_bGBk:visited:hover,button.cIcZl_bGBk:active,button.cIcZl_bGBk:hover{-webkit-text-decoration:").concat(theme.hoverTextDecoration || 'inherit', ";color:").concat(theme.hoverColor || 'inherit', ";text-decoration:").concat(theme.hoverTextDecoration || 'inherit', "}\n\n.cIcZl_bGBk.cIcZl_enfx,a.cIcZl_bGBk.cIcZl_enfx:link,a.cIcZl_bGBk.cIcZl_enfx:visited,button.cIcZl_bGBk.cIcZl_enfx{color:").concat(theme.colorInverse || 'inherit', "}\n\n.cIcZl_bGBk.cIcZl_enfx:focus,a.cIcZl_bGBk.cIcZl_enfx:link:focus,a.cIcZl_bGBk.cIcZl_enfx:visited:focus,button.cIcZl_bGBk.cIcZl_enfx:focus{outline-color:").concat(theme.focusInverseOutlineColor || 'inherit', "}\n\n.cIcZl_bGBk.cIcZl_enfx:active,.cIcZl_bGBk.cIcZl_enfx:focus,.cIcZl_bGBk.cIcZl_enfx:hover,a.cIcZl_bGBk.cIcZl_enfx:link:active,a.cIcZl_bGBk.cIcZl_enfx:link:focus,a.cIcZl_bGBk.cIcZl_enfx:link:hover,a.cIcZl_bGBk.cIcZl_enfx:visited:active,a.cIcZl_bGBk.cIcZl_enfx:visited:focus,a.cIcZl_bGBk.cIcZl_enfx:visited:hover,button.cIcZl_bGBk.cIcZl_enfx:active,button.cIcZl_bGBk.cIcZl_enfx:focus,button.cIcZl_bGBk.cIcZl_enfx:hover{color:").concat(theme.colorInverse || 'inherit', "}\n\nbutton.cIcZl_bGBk{-moz-appearance:none;-moz-user-select:text;-ms-user-select:text;-webkit-appearance:none;-webkit-user-select:text;appearance:none;background:none;border:none;cursor:pointer;font-size:1em;margin:0;padding:0;text-align:inherit;user-select:text}\n\n[dir=ltr] button.cIcZl_bGBk,[dir=rtl] button.cIcZl_bGBk{text-align:inherit}\n\n.cIcZl_dnnz{box-sizing:border-box;font-size:").concat(theme.iconSize || 'inherit', "}\n\n.cIcZl_ddMx .cIcZl_dnnz{-webkit-padding-end:").concat(theme.iconPlusTextMargin || 'inherit', ";-webkit-padding-start:0;padding-inline-end:").concat(theme.iconPlusTextMargin || 'inherit', ";padding-inline-start:0}\n\n[dir=ltr] .cIcZl_ddMx .cIcZl_dnnz{padding-left:0;padding-right:").concat(theme.iconPlusTextMargin || 'inherit', "}\n\n[dir=rtl] .cIcZl_ddMx .cIcZl_dnnz{padding-left:").concat(theme.iconPlusTextMargin || 'inherit', ";padding-right:0}\n\n.cIcZl_bkXt .cIcZl_dnnz{-webkit-padding-end:0;-webkit-padding-start:").concat(theme.iconPlusTextMargin || 'inherit', ";padding-inline-end:0;padding-inline-start:").concat(theme.iconPlusTextMargin || 'inherit', "}\n\n[dir=ltr] .cIcZl_bkXt .cIcZl_dnnz{padding-left:").concat(theme.iconPlusTextMargin || 'inherit', ";padding-right:0}\n\n[dir=rtl] .cIcZl_bkXt .cIcZl_dnnz{padding-left:0;padding-right:").concat(theme.iconPlusTextMargin || 'inherit', "}\n\n.cIcZl_FcDy.cIcZl_bkXt,.cIcZl_FcDy.cIcZl_ddMx{align-items:center}\n\n.cIcZl_bOQC{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n\nbutton.cIcZl_bOQC{width:100%}");
  },
  'root': 'cIcZl_bGBk',
  'inverse': 'cIcZl_enfx',
  'icon': 'cIcZl_dnnz',
  'iconPlacement--start': 'cIcZl_ddMx',
  'iconPlacement--end': 'cIcZl_bkXt',
  'truncates': 'cIcZl_FcDy',
  'ellipsis': 'cIcZl_bOQC'
};

/**
---
category: components
---
**/
var Link = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _deprecated.default)('5.40.0', {
  ellipsis: '<Link><TruncateText /></Link>'
}), _dec3 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Link, _Component);
  function Link() {
    var _getPrototypeOf2;
    var _this;
    (0, _classCallCheck2.default)(this, Link);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Link)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleClick = function (e) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick;
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      } else if (typeof onClick === 'function') {
        onClick(e);
      }
    };
    return _this;
  }
  (0, _createClass2.default)(Link, [{
    key: "focus",
    value: function focus() {
      (0, _findDOMNode.default)(this._link).focus();
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var Icon = this.props.icon;

      /*#__PURE__*/
      (/*#__PURE__*/
      0, _console.warn)(
      // if display prop is used, warn about icon or TruncateText
      this.props.display === void 0, '[Link] Using the display property with an icon may cause layout issues.');
      if (typeof this.props.icon === 'function') {
        return _react.default.createElement("span", {
          className: styles.icon
        }, _react.default.createElement(Icon, null));
      } else if (Icon) {
        return _react.default.createElement("span", {
          className: styles.icon
        }, Icon);
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classes,
        _this2 = this;
      var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        children = _this$props2.children,
        onClick = _this$props2.onClick,
        variant = _this$props2.variant,
        href = _this$props2.href,
        margin = _this$props2.margin,
        ellipsis = _this$props2.ellipsis,
        icon = _this$props2.icon,
        iconPlacement = _this$props2.iconPlacement,
        linkRef = _this$props2.linkRef,
        _elementRef = _this$props2.elementRef;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles.inverse, variant === 'inverse'), (0, _defineProperty2.default)(_classes, styles["iconPlacement--".concat(iconPlacement)], icon && this.hasVisibleChildren), (0, _defineProperty2.default)(_classes, styles.truncates, this.containsTruncateText), (0, _defineProperty2.default)(_classes, styles.ellipsis, ellipsis), _classes);
      var role = onClick && this.element !== 'button' ? 'button' : null;
      var type = onClick || this.element === 'button' ? 'button' : null;
      var tabIndex = role === 'button' && !disabled ? '0' : null;
      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, Link.propTypes), Link);
      var props = (0, _objectSpread2.default)({}, passthroughProps, {
        elementRef: function elementRef(el) {
          _this2._link = el;
          if (typeof linkRef === 'function') linkRef(el);
          if (typeof _elementRef === 'function') _elementRef(el);
        },
        as: this.element,
        display: this.display,
        margin: margin,
        className: (0, _classnames.default)(classes),
        href: href,
        onClick: this.handleClick,
        'aria-disabled': disabled ? 'true' : null,
        role: role,
        type: type,
        tabIndex: tabIndex
      });
      return _react.default.createElement(_View.default, props, icon && iconPlacement === 'start' && this.renderIcon(), children, icon && iconPlacement === 'end' && this.renderIcon());
    }
  }, {
    key: "display",
    get: function get() {
      if (this.props.display) {
        return this.props.display; // user-entered display property
      }
      if (this.props.ellipsis) {
        return 'block'; // can delete this block when ellipsis is removed
      }
      if (this.props.icon) {
        if (this.containsTruncateText) {
          return 'flex'; // TruncateText displays block, so avoid icon getting bumped
        } else {
          return 'inline-block'; // avoid irregularly shaped focus outline
        }
      } else if (this.containsTruncateText) {
        return 'block'; // TruncateText displays block, so container needs to as well
      } else {
        return 'auto';
      }
    }
  }, {
    key: "hasVisibleChildren",
    get: function get() {
      return (0, _hasVisibleChildren.default)(this.props.children);
    }
  }, {
    key: "element",
    get: function get() {
      return (0, _getElementType.default)(Link, this.props);
    }
  }, {
    key: "focused",
    get: function get() {
      return (0, _isActiveElement.default)(this._link);
    }
  }, {
    key: "focusable",
    get: function get() {
      return (0, _findFocusable.default)(this._link);
    }
  }, {
    key: "containsTruncateText",
    get: function get() {
      var truncateText = false;
      _react.default.Children.forEach(this.props.children, function (child) {
        if (child && (0, _matchComponentTypes.default)(child, ['TruncateText'])) {
          truncateText = true;
        }
      });

      /*#__PURE__*/
      (/*#__PURE__*/
      0, _console.warn)(
      // if display prop is used, warn about icon or TruncateText
      !truncateText || this.props.display === void 0, '[Link] Using the display property with TruncateText may cause layout issues.');
      return truncateText;
    }
  }]);
  Link.displayName = "Link";
  return Link;
}(_react.Component), _class2.propTypes = {
  href: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  variant: _propTypes.default.oneOf(['default', 'inverse']),
  /**
  * provides a reference to the underlying focusable (`button` or `a`) element
  */
  linkRef: _propTypes.default.func,
  /**
  * provides a reference to the underlying html element
  */
  elementRef: _propTypes.default.func,
  /**
  * the element type to render as (will default to `<a>` if href is provided)
  */
  as: _propTypes.default.elementType,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  /**
  * __DEPRECATED (5.40.0)__ Use `<Link><TruncateText /></Link>` instead.
  */
  ellipsis: _propTypes.default.bool,
  // eslint-disable-line react/require-default-props

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  /**
  * Add an SVG icon to the Link. Do not add icons directly as
  * children.
  */
  icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  /**
  * Place the icon before or after the text in the Link.
  */
  iconPlacement: _propTypes.default.oneOf(['start', 'end']),
  /**
  * Set the CSS display property of the Link element. 'auto' sets no display property.
  */
  display: _propTypes.default.oneOf(['auto', 'block', 'inline-block', 'flex', 'inline-flex'])
}, _class2.defaultProps = {
  href: void 0,
  elementRef: void 0,
  disabled: false,
  onClick: void 0,
  margin: void 0,
  icon: void 0,
  display: void 0,
  variant: 'default',
  as: 'button',
  linkRef: function linkRef(link) {},
  iconPlacement: 'start'
}, _temp)) || _class) || _class) || _class);
var _default = Link;
exports.default = _default;